import { render, staticRenderFns } from "./SplitHero.vue?vue&type=template&id=46557316&scoped=true&"
import script from "./SplitHero.vue?vue&type=script&lang=js&"
export * from "./SplitHero.vue?vue&type=script&lang=js&"
import style0 from "./SplitHero.vue?vue&type=style&index=0&id=46557316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46557316",
  null
  
)

export default component.exports